import { useAppSelector } from 'shared/store/store'
import { useGetTerminologyQuery } from 'shared/store/terminology/terminology.service'
import {
  getActiveClientId,
  getActiveClient,
} from 'shared/store/clients/selectors'
import { staticTerminology } from 'shared/constants/terminology'
import { getPropertySectionNoTitle } from 'shared/utils/client'

export const useTerminology = () => {
  const clientId = useAppSelector(getActiveClientId)
  const client = useAppSelector(getActiveClient)
  const { data: terminology } = useGetTerminologyQuery(clientId)

  const terms = { ...staticTerminology, ...terminology }
  const companyTypeCode = client?.clientType.companyTypeCode

  const propertySectionNoTitle = getPropertySectionNoTitle(
    terms.Enhet,
    companyTypeCode,
    true
  )

  const propertySectionLongNoTitle = getPropertySectionNoTitle(
    terms.Enhet,
    companyTypeCode,
    false
  )

  return {
    ...terms,
    propertySectionNoTitle,
    propertySectionLongNoTitle,
  }
}
